"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import InnerDivider, { dividerClasses } from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
import { useCheckThemeContext } from "../../hooks/useCheckThemeContext";
const StyledDivider = styled(InnerDivider, {
    shouldForwardProp: (prop) => !["noVerticalSpacing", "inset", "inverted"].includes(prop.toString()),
})(({ children, inverted, noVerticalSpacing, theme, variant }) => {
    const dt = theme.pixel;
    const vertical = `&.${dividerClasses.vertical}`;
    const horizontal = `&:not(.${dividerClasses.vertical})`;
    return Object.assign(Object.assign(Object.assign({}, (!children && {
        borderColor: dt.color.outlineVariant,
    })), (inverted && Object.assign(Object.assign({ color: dt.color.onPrimary.key }, (!children && {
        opacity: dt.opacity[50],
        borderColor: dt.color.onPrimary.key,
    })), { "&&::before, &&::after": {
            opacity: dt.opacity[50],
            borderColor: dt.color.onPrimary.key,
        } }))), { [horizontal]: Object.assign(Object.assign(Object.assign({}, (noVerticalSpacing && {
            marginTop: 0,
            marginBottom: 0,
        })), (variant === "middleSmall" && {
            marginLeft: dt.space.inline.xSmall2,
            marginRight: dt.space.inline.xSmall2,
        })), (variant === "middleMedium" && {
            marginLeft: dt.space.inline.small,
            marginRight: dt.space.inline.small,
        })), [vertical]: Object.assign(Object.assign(Object.assign({}, (noVerticalSpacing && {
            marginLeft: 0,
            marginRight: 0,
        })), (variant === "middleSmall" && {
            marginTop: dt.space.inline.xSmall2,
            marginBottom: dt.space.inline.xSmall2,
        })), (variant === "middleMedium" && {
            marginTop: dt.space.inline.small,
            marginBottom: dt.space.inline.small,
        })) });
});
export const Divider = React.forwardRef((props, ref) => {
    useCheckThemeContext("Divider");
    return _jsx(StyledDivider, Object.assign({}, props, { "data-pixel": "Divider", ref: ref }));
});
